import { DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';
import _ from 'underscore';

import { Messages } from '../../codegen/Localize';
import { IOrderClause } from '../../spacesPlatform/serverApi/types/IOrderClause';
import { ISiteUserInfo } from '../../userManagement/users/models/ISiteUserInfo';
import { AddUsersToAdminProfileCellFormatterFactory } from './AddUsersToAdminProfileCellFormatter';
import { AddUsersToAdminProfileDataKeys } from './AddUsersToAdminProfileDialog';
import { dataGridContainerStyle, dataGridRowHeight, dataGridStyle } from './styles/AddUsersToAdminProfileDialogStyles';

export interface AddUsersToAdminProfileGridProps {
  userList: ISiteUserInfo[];
  rowCheckboxState: _.Dictionary<string>;
  handleRowCheckboxChange: (user: ISiteUserInfo) => void;
  emptyChild: JSX.Element;
  currentColumnSortOrder: IOrderClause;
  handleColumnSortOrderChange: (field: string) => void;
  shouldAskForNextPage: (endIndex: number) => boolean;
  askForNextPage: () => void;
}

export class AddUsersToAdminProfileGrid extends React.Component<AddUsersToAdminProfileGridProps> {
  private rows: DataGrid.Row[] = [];
  private cols: DataGrid.Column[] = [];

  private getRowStore = (): DataGrid.RowStore => ({
    getItems: (start: number, end: number, rowHandler: (rows: DataGrid.Row[]) => void) => {
      rowHandler(this.rows);
      if (this.props.shouldAskForNextPage(end)) {
        this.props.askForNextPage();
      }
    },
  } as DataGrid.RowStore);

  private generateCols(): DataGrid.Column[] {
    return [
      {
        name: 'select',
        dataKey: AddUsersToAdminProfileDataKeys.Select,
        headerText: Messages.column_select(),
        preferredWidth: 56,
        resizable: false,
        sortable: false,
        cellFormatter: AddUsersToAdminProfileCellFormatterFactory,
      },
      {
        name: 'displayName',
        dataKey: AddUsersToAdminProfileDataKeys.DisplayName,
        sortable: false,
        growToFit: true,
        headerText: Messages.column_fullName(),
        cellFormatter: AddUsersToAdminProfileCellFormatterFactory,
      },
      {
        name: 'username',
        dataKey: AddUsersToAdminProfileDataKeys.Username,
        sortable: false,
        growToFit: true,
        headerText: Messages.column_username(),
        cellFormatter: AddUsersToAdminProfileCellFormatterFactory,
      },
    ];
  }

  private generateRows(): DataGrid.Row[] {
    return this.props.userList.map((user, index) => {
      const checkboxCellData = {
        checkboxState: this.props.rowCheckboxState[user.id],
        onCheckboxChanged: () => this.props.handleRowCheckboxChange(user),
      };
      return {
        key: String(index),
        data: {
          [AddUsersToAdminProfileDataKeys.Select]: checkboxCellData,
          [AddUsersToAdminProfileDataKeys.DisplayName]: user.displayName,
          [AddUsersToAdminProfileDataKeys.Username]: user.username,
        },
      };
    });
  }

  public render(): JSX.Element {
    this.cols = this.generateCols();
    this.rows = this.generateRows();
    return (
      <div className={dataGridContainerStyle}>
        <div className={'tb-spaces-list-view'}>
          <DataGrid
            config={{ rowOuterHeight: dataGridRowHeight, rememberLastScrollPos: true }}
            emptyChild={this.props.emptyChild}
            cols={this.cols}
            rowStore={this.getRowStore()}
            showVerticalGridLines={false}
            showHorizontalGridLines={false}
            showRowBanding={false}
            style={dataGridStyle}
          />
        </div>
      </div>
    );
  }
}
